<template>
  <div class="qr-ctn">
    <img src="@/assets/images/codigo-qr-contato-onesti.png" class="contact-qr" :alt="`${$t('alt.qr')} `">
  </div>
</template>
<script>
export default {
  name: 'ContactQr'
}
</script>
<style scoped lang="sass">
@tailwind utilities

.qr-ctn
  @apply absolute overflow-hidden w-40 h-40
  border-radius: 6px
  bottom: 10px
  right: 10px

.contact-qr
  height: inherit
  width: inherit
</style>
